export const FEATURE_FLAG_SCENARIOS = {
  DISABLED: 'FEATURE_FLAG_DISABLED',
  ENABLED: 'FEATURE_FLAG_ENABLED',
} as const;

type FeatureFlagKey = keyof typeof FEATURE_FLAG_SCENARIOS;

export type FeatureFlagId = (typeof FEATURE_FLAG_SCENARIOS)[FeatureFlagKey];
